import styled from "styled-components";

export default styled.div`
  ${(props) => props.theme.media.lg} {
  }
  .container.custom-container {
    @media (min-width: 1200px) {
      max-width: 1170px;
    }
  }
  .scheduled-consultation {
    margin-top: 0.5rem;
    .image-wrapper {
      img {
        display: block;
        margin: auto;
        max-width: 350px;
      }
    }
    .consultation-text-container {
      .consultation-title {
        width: 100%;
        padding: 0 0.5rem;
        margin: auto;
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 2rem;
      }
      p {
        font-family: Inter;
        font-size: 16px;
        line-height: 24px;
        width: 100%;
        margin: auto;
        text-align: center;
        margin-bottom: 2rem;
        color: #3f5261;
      }

      .btn {
        display: table;
        margin: 0 auto 2rem;
        font-size: 22px;
        ${(props) => props.theme.media.lg} {
          margin: 0;
          margin-top: 43px;
          padding: 12px 22px;
          font-size: 22px;
        }
      }

      .consultation-features {
        list-style-type: none;
        counter-reset: custom-counter;
        padding-left: 0;
        li {
          padding-top: 4rem;
          counter-increment: custom-counter;
          position: relative;
          text-align: center;
          font-size: 24px;
          font-weight: 500;
          line-height: 1.2;
          max-width: 300px;
          margin: auto;
          &:before {
            content: counter(custom-counter);
            position: absolute;
            display: flex;
            height: 36px;
            width: 36px;
            justify-content: center;
            align-items: center;
            background: #fe6712;
            color: #ffffff;
            font-weight: 500;
            font-size: 21px;
            border-radius: 50%;
            left: 50%;
            transform: translateX(-50%);
            top: 1rem;
          }
        }
      }
    }
  }

  ${(props) => props.theme.media.lg} {
    .scheduled-consultation {
      margin-top: 2rem;
      display: flex;
      .image-wrapper {
        img {
          max-width: 38rem;
        }
      }
      .consultation-text-container {
        margin-left: 0px;

        .consultation-title {
          margin-top: 0px;
          font-family: "Poppins";
          font-weight: 600;
          font-size: 36px;
          text-align: left;
          max-width: 500px;
          margin-left: 0;
          margin-bottom: 2rem;
          width: 100%;
        }
        p {
          width: 90%;
          margin-left: 0;
          text-align: left;
        }
        .consultation-features {
          padding-left: 46px;

          li {
            padding-top: 0;
            position: relative;
            margin-top: 26px;
            text-align: left;
            max-width: none;
            line-height: 1.2;
            &:before {
              left: -46px;
              top: -5px;
              transform: translateX(0);
            }
          }
        }
      }
    }
  }
  .getting-started-cards .mid-title {
    font-size: 32px;
    text-align: center;
    font-weight: 600;
    margin: 2rem auto;
    padding: 0 1rem;
    max-width: 410px;
    ${(props) => props.theme.media.md} {
      font-size: 40px;
      margin: 4rem auto;
      width: auto;
      max-width: 1110px;
    }
  }

  .works-container {
    max-width: 1205px;
    margin: auto;
    display: grid;
    padding-bottom: 40px;
    grid-template-columns: 1fr;
    margin-top: 2rem;
    margin-bottom: 2.5rem;
    place-items: flex-start;
    grid-gap: 30px;
    place-items: center;
    padding: 0 24px;

    ${(props) => props.theme.media.md} {
      margin-top: 3.2rem;
      margin-bottom: 97px;
      grid-gap: 37px;
      padding: 0;
    }
    ${(props) => props.theme.media.lg} {
      grid-template-columns: repeat(3, auto);
    }
  }

  .mid-title {
    h2 {
      color: #3f5261;
      font-size: 24pt;
      text-align: center;
      font-weight: 600;
      margin-bottom: 0;
    }
  }
  .getting-started-card {
    box-shadow: 0px 3px 11px #00000029;
    border: none;
  }
  .getting-started-card-body {
    padding: 1rem 1rem;
    max-width: 358px;

    img {
      height: 100px;
    }
    ${(props) => props.theme.media.md} {
      min-height: 348px;
      padding: 0.7rem;
      margin-top: 0rem;
    }
    .image {
      margin-top: 15px;
      min-height: 70px;
      img {
        height: 100px;
        margin: auto;
        display: block;
      }
      ${(props) => props.theme.media.md} {
        margin-top: 30px;
      }
    }

    .text {
      margin-top: 25px;
      .getting-started-title {
        color: #3f5261;
        text-align: center;
        font-size: 22px;
        ${(props) => props.theme.media.lg} {
          font-size: 24px;
        }
        font-weight: 600;
        margin-bottom: 25px;
        line-height: 1.4;
      }

      .getting-started-description {
        text-align: center;
        font-family: Inter;
        color: #3f5261;
        font-size: 16px;
        line-height: 24px;
        padding: 0;
        ${(props) => props.theme.media.lg} {
          text-align: center;
          padding: 0px 1.125rem;
        }
      }
    }
  }

  .why-account {
    // padding: 0 10px;
    .why-container {
      background: #f8f6f4;
      padding: 2rem 1.5rem 0;
    }
    .why-title {
      font-weight: 600;
      font-size: 30px;
      white-space: pre;
    }
    .why-content {
      display: block;
      .image-wrap {
        margin-top: 70px;
        width: 115%;
        margin-left: -20%;
        img {
          display: block;
          margin: auto;
          margin-top: -30px;
          margin-left: 55px;
        }
      }

      .why-text-container {
        .title {
          color: #3f5261;
          font-weight: 500;
          margin-bottom: 15px;
          line-height: 1.3;
          margin-top: 1.2rem;
          padding: 0 1rem;
          text-align: center;
          font-size: 1.875rem;
        }

        .subtitle {
          color: #3f5261;
          p {
            font-size: 16px;
            font-weight: 500;
            line-height: 1.4;
            text-align: center;
            max-width: 338px;
            margin-left: auto;
            margin-right: auto;
            letter-spacing: -0.5px;
          }
        }
      }
    }
  }
  ${(props) => props.theme.media.md} {
    // background: #f8f6f4;
    .why-account {
      padding-top: 44px;
    }
  }
  ${(props) => props.theme.media.lg} {
    .why-account {
      padding-top: 44px;
      .why-container {
        background: #f8f6f4;
        max-width: 1050px;
        padding: 3rem 0rem 0;
        margin: 0 auto;
        border-radius: 30px;
      }
      .why-title {
        color: #3f5261;
        font-size: 40px;
        line-height: 48px;
        font-weight: 600;
        margin: 0 auto;
      }
      .why-content {
        max-width: 1150px;
        margin: 0 auto;
        display: grid !important;
        grid-template-columns: 1fr 1fr;

        .image-wrap {
          margin-top: 40px;
          width: 100%;
          margin-left: 0%;
          img {
            margin-top: 0px;
            float: right;
            // max-width: none !important;
          }
        }

        .why-text-container {
          padding-left: 33px;
          padding-top: 35px;
          max-width: 525px;
          .title {
            font-size: 30px;
            margin-top: 0;
            padding: 0;
            text-align: left;
          }

          .subtitle {
            p {
              text-align: left;
              max-width: 445px;
              letter-spacing: normal;
            }
          }
        }
      }
    }
  }
`;
